/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateFintecturePaymentLinkRequest } from '../models/CreateFintecturePaymentLinkRequest';
import type { HandleFintectureWebhookRequest } from '../models/HandleFintectureWebhookRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class InvoicePaymentsService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Webhook Fintecture
     * Appele par Fintecture quand l'etat d'un paiement change (`session_id`, `status`...). Met a jour la facture correspondante quand le virement est confirme. 404 si la session est inconnue.
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    public invoicePaymentsHandleFintectureWebhook(
        requestBody: HandleFintectureWebhookRequest,
    ): CancelablePromise<{
        success: boolean;
        session_id: string;
        status: string;
        payment: ({
            payment_created: boolean;
            already_processed: boolean;
            fintecture_status: string;
            amount: string;
            invoice_id: string;
            lola_payment_id: string;
            lola_payment: Array<any>;
        } | {
            payment_created: boolean;
            error: string;
            detail: string;
        } | {
            payment_created: boolean;
            already_processed: boolean;
            fintecture_status: string;
        } | {
            payment_created: boolean;
            already_processed: boolean;
            lola_payment_id: string;
        });
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/fintecture/webhook',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                403: `Authorization error`,
                422: `Erreur de validation`,
            },
        });
    }
    /**
     * L'entreprise accepte-t-elle le paiement en ligne ?
     * Reponse : `{ has_account }` — `true` si des identifiants Fintecture sont configures pour l'entreprise. Appele par l'espace client avant d'afficher le bouton de paiement.
     * @returns any
     * @throws ApiError
     */
    public invoicePaymentsCustomerHasFintecture(): CancelablePromise<{
        has_account: boolean;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/fintecture/check_account',
            errors: {
                400: `Header Company-Key absent.`,
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                404: `Aucune entreprise ne correspond a la Company-Key fournie.`,
            },
        });
    }
    /**
     * Creer un lien de paiement Fintecture
     * Initie un virement SEPA immediat (`amount`, `communication`, `customerFullName`, `customerEmail`, `state`, `redirectUri`) pour une facture et enregistre la session de paiement. Reponse : `{ url, session_id }` — `url` est la page de paiement bancaire vers laquelle rediriger le client. 400 `{ error }` si Fintecture refuse.
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    public invoicePaymentsCreateFintecturePaymentLink(
        requestBody: CreateFintecturePaymentLinkRequest,
    ): CancelablePromise<{
        url: string;
        session_id: string;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/fintecture/generate_link',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                404: `Aucune entreprise ne correspond a la Company-Key fournie.`,
                422: `Erreur de validation`,
            },
        });
    }
}
